import { createBrowserRouter, Navigate } from 'react-router-dom';
import PortalShell from './components/PortalShell';
import Dashboard      from './pages/Dashboard';
import Marketplace    from './pages/Marketplace';
import Missions       from './pages/Missions';
import MissionDetail  from './pages/MissionDetail';
import MissionCRA     from './pages/MissionCRA';
import MissionDocs    from './pages/MissionDocs';
import Account        from './pages/Account';

export const router = createBrowserRouter([
  {
    path: '/',
    Component: PortalShell,
    children: [
      { index: true, element: <Navigate to="/dashboard" replace /> },
      { path: 'dashboard',                Component: Dashboard },
      { path: 'marketplace',              Component: Marketplace },
      { path: 'missions',                 Component: Missions },
      { path: 'missions/:id',             Component: MissionDetail },
      { path: 'missions/:id/cra',         Component: MissionCRA },
      { path: 'missions/:id/docs',        Component: MissionDocs },
      { path: 'account',                  Component: Account },
      { path: '*', element: <Navigate to="/dashboard" replace /> },
    ],
  },
]);
